import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'

// ── Production Console Guard ─────────────────────────────────────────────────
// Suppress debug output in production builds. Errors are always preserved.
if (import.meta.env.PROD) {
  console.log = () => { };
  console.warn = () => { };
  console.info = () => { };
  console.debug = () => { };
  console.group = () => { };
  console.groupEnd = () => { };
  console.table = () => { };
  console.time = () => { };
  console.timeEnd = () => { };
}
// ────────────────────────────────────────────────────────────────────────────

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)

// Register service worker for offline support
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Silent fail — SW registration is optional
    });
  });
}
